// extracted by mini-css-extract-plugin
export default {"down-arrow":"Calendar_down-arrow__1B3N0","nextprev-icon":"Calendar_nextprev-icon__9CiPn"};